import useApi from "@/services/useApi";
import {computed, reactive} from "vue"

export default function useIntegration() {
    const {api, headers} = useApi();
    const totals = reactive({
        incoming: null,
        outgoing: null,
        dialogs: null,
        queue: null,
    })

    const baseStats = computed(() => ([
        {icon: "arrow-2", count: totals.incoming, key: "incoming"},
        {icon: "arrow-1", count: totals.outgoing, key: "outgoing"},
        {icon: "chat-1-1", count: totals.dialogs, key: "dialogs"},
        {icon: "checklist-1", count: totals.queue, key: "queue"},
    ]))

    function resetTotals() {
        for (const k in totals) totals[k] = 0
    }

    function mergeCounts(partial) {
        for (const k in totals) {
            totals[k] += Number(partial?.[k] ?? 0)
        }
    }

    async function runChannel(name, loader) {
        try {
            const res = await loader()
            mergeCounts(res)
            return res
        } catch (e) {
            throw e
        }
    }

    async function loadAllCounts() {
        resetTotals()

        const tasks = [
            runChannel("viber", loadCountViber),
            runChannel("whatsapp", loadCountWhatsapp),
            runChannel("telegram", loadCountTelegram),
            runChannel("tiktok", loadCountTiktok),
        ]

        const results = await Promise.allSettled(tasks)

        const rejected = results.filter(r => r.status === "rejected")
        return {results, rejectedCount: rejected.length}
    }

    const loadCountViber = async () => {
        try {
            const response = await api.get("/api/messages/stats/viber", {
                headers,
            });
            return response.data.data
        } catch (error) {
            console.error("loadCount", error);
            throw new Error(error);
        }
    }

    const loadCountTelegram = async () => {
        try {
            const response = await api.get("/api/messages/stats/telegram", {
                headers,
            });
            return response.data.data
        } catch (error) {
            console.error("loadCount", error);
            throw new Error(error);
        }
    }

    const loadCountWhatsapp = async () => {
        try {
            const response = await api.get("/api/messages/stats/whatsapp", {
                headers,
            });
            return response.data.data
        } catch (error) {
            console.error("loadCount", error);
            throw new Error(error);
        }
    }

    const loadCountTiktok = async () => {
        try {
            const response = await api.get("/api/messages/stats/tiktok", {
                headers,
            });
            return response.data.data
        } catch (error) {
            console.error("loadCount", error);
            throw new Error(error);
        }
    }

    return {
        loadAllCounts,
        baseStats,
    };
}
